import React from "react";
import Nav from "react-bootstrap/Nav";
import { useHistory } from "react-router";
import { NavDropdown } from "react-bootstrap";

export default function ServiceMenu() {
  const history = useHistory();

  return (
    <>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("MGBarcodes");
          }}
        >
          จัดการพัสดุ
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          onClick={(e) => {
            history.push("myReceipt");
          }}
        >
          การพิมพ์ใบเสร็จ
        </Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <NavDropdown title="รายงาน" id="basic-nav-dropdown">
          <NavDropdown.Item
            onClick={(e) => {
              history.push("ReportStockIn");
            }}
          >
            พิมพ์รายงานทะเบียนคุม
          </NavDropdown.Item>
        </NavDropdown>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link
          eventKey="/home"
          onClick={(e) => {
            history.push("historyCOD");
            }}
          >
            ประวัติCOD
        </Nav.Link>
      </Nav.Item>
    </>
  );
}
